// src/components/study/NextLessonButton.jsx
import React from 'react';
import { ArrowRight } from 'lucide-react';

const NextLessonButton = ({ nextLesson, onNavigate }) => {
  // If there's no next lesson, don't render anything
  if (!nextLesson) {
    return null;
  }

  return (
    <div className="fixed bottom-0 right-0 p-4 sm:p-6 z-50 animate-slide-up">
      <button
        onClick={onNavigate}
        className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white font-bold py-3 px-6 rounded-xl shadow-2xl flex items-center justify-center gap-3 transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-3xl focus:outline-none focus:ring-4 focus:ring-blue-300"
      >
        <span>
          Next: <span className="font-normal">{nextLesson.title}</span>
        </span>
        <ArrowRight className="w-5 h-5" />
      </button>
    </div>
  );
};

export default NextLessonButton;